module.exports = __webpack_public_path__ + "img/bannerLoginPageMobile.4bee20e9.png";